<template>
  <div>
    <app-collapse-item v-bind:title="title" class="border rounded my-1">
      <template #header>
        <div class="lead collapse-title">
          {{ title }}
        </div>
        <div>
          <b-badge v-if="status" class="mx-50" variant="light-success">
            فعال
          </b-badge>
          <b-badge v-else class="mx-50" variant="light-secondary">
            متوقف
          </b-badge>
          <b-dropdown variant="link" no-caret right>
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item variant="primary" @click="$emit('editClicked')" v-can="{slug:$route.meta.slug, action:'U'}">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">تعديل</span>
            </b-dropdown-item>

            <b-dropdown-item variant="danger" @click="$emit('deleteClicked')" v-can="{slug:$route.meta.slug, action:'D'}">
              <feather-icon icon="Trash2Icon" />
              <span class="align-middle ml-50">حذف</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>
      <slot />
    </app-collapse-item>
  </div>
</template>

<script>
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import { BButton, BBadge, BDropdown, BDropdownItem } from "bootstrap-vue";
import { mapGetters } from "vuex";
export default {
  components: {
    AppCollapseItem,
    BButton,
    BBadge,
    BDropdown,
    BDropdownItem,
  },
  props: {
    title: String,
    status: Boolean,
    items: [],
  },
  computed:{
    ...mapGetters("NgoProfile", [ "canAddTransaction"]),

  },
};
</script>

<style lang="scss">
.btn.dropdown-toggle {
  padding: 0px;
}
</style>
